import firebase from "firebase";
import { OlabItem } from "./olabitem.js";
// import { OlabUtils } from "./olabutils.js";

class OlabSequence extends OlabItem {
  static getCreateItemConverter() {
    // Firestore data converter
    let olabItemConverter = {
      toFirestore: function(item) {
        return {
          editDisplayState: item.editDisplayState,
          olab_id: item.olab_id,
          olab_type: item.olab_type,
          name: item.name,
          name_uc: item.name_uc,
          library_id: item.library_id,
          source: item.source,
          creator: item.creator,
          creator_uc: item.creator_uc,
          seq_origin: item.seq_origin,
          seq: item.seq,
          gene_stats: item.gene_stats,
          desc: item.desc,
          created_date: firebase.firestore.FieldValue.serverTimestamp()
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabItem(data);
      }
    };
    return olabItemConverter;
  }

  static getUpdateItemConverter() {
    // Firestore data converter
    let olabItemConverter = {
      toFirestore: function(item) {
        return {
          editDisplayState: item.editDisplayState,
          name: item.name,
          name_uc: item.name_uc,
          // olab_id and library_id can't be changed.
          // olab_id: item.olab_id,
          // olab_type: item.olab_type,
          // library_id: item.library_id,
          source: item.source,
          creator: item.creator,
          creator_uc: item.creator_uc,
          seq_origin: item.seq_origin,
          seq: item.seq,
          gene_stats: item.gene_stats,
          desc: item.desc,
          updated_date: firebase.firestore.FieldValue.serverTimestamp()
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabItem(data);
      }
    };
    return olabItemConverter;
  }
}

export { OlabSequence };
